/* istanbul ignore file */
import { TextArea, useInputHelper, useFormContext } from 'framework/form';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import { getLastSource } from 'framework/utils';
import { Grid2 as Grid } from '@mui/material';
import { AccountInput } from 'domain/shared/ledger';
import { BudgetCategoryDropdown } from 'domain/shared/budget';
import TransferCurrencyInput from './TransferCurrencyInput';
import { isBudgetCategoryRequired } from 'domain/shared/budget';

const TransferInput = ({ className, disabled, ...props }: any) => {
  const { searchJournalEntriesAccount } = useLedgerService();
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback() as any;

  const transfer = getValue() || ({} as any);
  const source = getSource();
  const { data = {} } = useFormContext();
  const asOfDate: string = data.asDateOf;

  const onChangeCallback = (value: any, additionalValues: Dictionary<any> = {}) => {
    rawOnChangeCallback({
      [source]: {
        ...transfer,
        ...getLastSource(value),
        ...additionalValues,
      },
    });
  };

  const onAccountChangeCallback = (value: any) => {
    onChangeCallback(value, {
      currency: value.currency,
    });
  };

  return (
    <Grid
      container
      spacing={2}
      width="100%"
      sx={theme => ({
        [theme.breakpoints.up('sm')]: {
          flexWrap: 'nowrap',
        },
      })}
    >
      <Grid size={{ xs: 12, xl: 3 }} sx={{ minWidth: 185 }}>
        <AccountInput
          source={`${source}.accountId`}
          label="Account"
          value={transfer.accountId}
          onChangeCallback={onAccountChangeCallback}
          disabled={disabled}
          cacheKey="ledger-accounts"
          loadDataMethod={searchJournalEntriesAccount}
        />
      </Grid>
      <Grid size={{ xs: 12, xl: 2 }} sx={{ flexShrink: 1, flexGrow: 0 }}>
        <TransferCurrencyInput
          source={`${source}.debit`}
          label="Debit"
          onChangeCallback={onChangeCallback}
          disabled={!!transfer.credit || disabled}
          currency={transfer.currency}
        />
      </Grid>
      <Grid size={{ xs: 12, xl: 2 }} sx={{ flexShrink: 1, flexGrow: 0 }}>
        <TransferCurrencyInput
          source={`${source}.credit`}
          label="Credit"
          onChangeCallback={onChangeCallback}
          disabled={!!transfer.debit || disabled}
          currency={transfer.currency}
        />
      </Grid>
      <Grid size={{ xs: 12, xl: 2 }} sx={{ flexShrink: 1, flexGrow: 0 }}>
        <BudgetCategoryDropdown
          disabled={!isBudgetCategoryRequired(transfer.accountId)}
          source={`${source}.attributes.budgetCategory`}
          label="Budget category"
          dateValue={asOfDate}
          accountIdValue={transfer.accountId}
        />
      </Grid>
      <Grid size={{ xs: 12, xl: 3 }} sx={{ flexShrink: 1, flexGrow: 1 }}>
        <TextArea
          source={`${source}.description`}
          value={transfer.description}
          label="Description"
          onChangeCallback={onChangeCallback}
          disabled={disabled}
          rows={1}
        />
      </Grid>
    </Grid>
  );
};

export default TransferInput;
